export const PIN = "pinStatus";
export const PREVIEW = "preview";
export const TYPE = "type";
export const NAME = "name";
export const THERAPUETIC_AREA = "therapeuticArea";
export const GROUP = "groupName";
export const STEPS = "stepsCount";
export const DURATION = "timeToComplete";
export const LANGUAGE = "languages";
export const LAST_MODIFIED = "modifiedTime";
export const TAGS = "tags";
export const STUDIES = "studyCount";
export const ACTION = "action";
export const CREATED_BY = "createdBy";
export const OBJECTIVE = "objective";
export const EMPTY_PIN = "emptyPin";
export const EMPTY_SPACING = "emptySpacing";
export const ABBREVIATION = "abbreviation";
export const VERSION = "Version";
export const INSTANCES = "Instances";
